import RowStack from '@common-components/common/row-stack/RowStack';
import { setIsReadOnly, setSlugBotId } from '@common/reducers/ChatbotReducer';
import { handleSelectChatbotThunk } from '@common/reducers/ChatbotThunks';
import { DBBotThunks } from '@common/reducers/DBServiceThunks';
import { useAppDispatch } from '@common/reducers/hooks/store.hook';
import { useWebSelector } from '@website/store/web-store';
import { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import classes from "./bt-chatbot.module.scss";
import ToolSettingsDialog from './bt-nodes/agent/tools/settings/tool-settings-dialog';
import ToolSettingsFactory from './bt-nodes/agent/tools/settings/tool-settings-factory';
import ChatbotFlow from './chatbot-flow';
import ChatbotToolBar from './chatbot-toolbar';
import { AnalyticsService } from '@common/services/analytics-service';
import { reportAgentEvent } from '@common/services/agent-analytics';

export default function BTChatBotView() {
    const { botId } = useParams();
    
    const dispatch = useAppDispatch();
    // Stable across renders — a fresh AnalyticsService each render previously made
    // the mount effect (which lists it as a dep) re-run on every render, re-firing
    // prepareFlow() + the bot_editor_viewed event repeatedly.
    const analytics = useMemo(() => new AnalyticsService(), []);
    
    // Get tool settings modal state from Redux using the web store selector
    const { isOpen, toolName, initialSettings } = useWebSelector(state => {
        return state.ToolSettingsModalReducer;
    });

    const prepareFlow = useCallback(async () => {
        await dispatch(setIsReadOnly(false));
        
        if (botId) {
            // await dispatch(DBBotThunks.find({ _id: botId }));
            await dispatch(setSlugBotId(botId));
            await dispatch(handleSelectChatbotThunk(botId));
        } else {
        }
        
    }, [botId, dispatch]);

    useEffect(() => {
        prepareFlow();
        
        // Track bot editor page view (bot_editor_viewed mirrors to the durable bus
        // automatically; agent_builder_opened is the unified builder-open signal).
        analytics.event('bot_editor_viewed', {
            category: 'bot_navigation',
            action: 'view_bot_editor',
            bot_id: botId || 'new',
            editor_type: botId ? 'edit_existing' : 'create_new'
        });
        reportAgentEvent('agent_builder_opened', 'gemini', { agentId: botId ?? undefined });
    }, [botId, prepareFlow, analytics]);

    
    return (
        <>
            <ReactFlowProvider>
                <RowStack className={classes.wrapper}>
                    <ChatbotToolBar />
                    <ChatbotFlow />
                </RowStack>
            </ReactFlowProvider>
            
            {/* Global Tool Settings Modal */}
            {toolName && (
                <ToolSettingsDialog
                    open={isOpen}
                    toolName={toolName}
                    initialSettings={initialSettings}
                >
                    <ToolSettingsFactory 
                        toolName={toolName} 
                        initialSettings={initialSettings}
                    />
                </ToolSettingsDialog>
            )}
        </>
    );
}